@if (!isAuthenticated()) {
  <div class="authentication-container normal-bg-color">
    <div class="authentication-container__auth-error-container">
      @if (authErr !== '') {
        <div class="authentication-container__auth-error">
          <mat-icon>
            error
          </mat-icon>

          <span>
            {{authErr}}
          </span>

          <button
            mat-flat-button
            color="warn"
            (click)="this.redirectToLogin()"
          >
            {{'TRANS__APP_COMPONENT__BACK_TO_LOGIN' | translate}}
          </button>
        </div>
      }
    </div>

    <!-- Primus loader -->
    @if (!showApiSelector && !isAuthenticated() && !hideLoader && authErr === '') {
      <div id="loader" class="authentication-container__loading-container">
        <div class="authentication-container__loading">
          <div class="authentication-container__spinner-container">
            <mat-spinner
              color="primary"
              diameter="50"
              id="awaiting-authentication"
              class="authentication-container__spinner"
            ></mat-spinner>

            <div>
              <span>
                {{'TRANS__APP_COMPONENT__LOADING_CONTENTS' | translate}}
              </span>

              ...
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
